import { matchPath } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Cookies from 'js-cookie';

import { loggedUser as mockLoggedUser } from 'src/mocks';
import { config, routes, pagination } from 'src/constants';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { User } from 'src/core/models';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getLoggedUserData = () => {
  const additionalData = !config.isDevEnv && {
    currencyCode: Cookies.get('CK_CURRENCY_CODE'),
    displayLang: Cookies.get('CK_LANG_CODE')
  };

  return config.isDevEnv || config.isTestEnv ? new User({ ...mockLoggedUser, ...additionalData }) :
    new User({
      ...LocalStorageService.getLoggedUser(),
      ...additionalData
    });
};

export const getUserCurrency = () => {
  const user = getLoggedUserData();

  return user.currencyCode;
};

export const isCSRUser = () => {
  const user = getLoggedUserData();

  return user.isCSR;
};

export const getUserFullName = () => {
  const user = getLoggedUserData();

  return `${user.firstName} ${user.lastName}`;
};

export const redirectToLogin = () => {
  const tfkong = Cookies.get('tfkong');

  if (tfkong) {
    window.location.pathname = '/auth/login';
  }

  window.location.pathname = '/account-center/signin-identifier.html';
};

const matchPaths = (path, currentLocation) => matchPath(currentLocation, {
  path: `${config.baseRoute}${path}`,
  exact: true,
  strict: false
});

export const isRouteMatching = (route) => {
  const currentLocation = window.location.pathname;
  const matchObj = matchPaths(route, currentLocation);

  return !!(matchObj && matchObj.isExact);
};

export const getRouteId = () => {
  const currentLocation = window.location.pathname;

  const result = routes.PATHS.map((path) => matchPaths(path, currentLocation))
    .find((matchObj) => !!(matchObj && matchObj.isExact));

  return result?.params?.id;
};

export const getPaginationConfig = (
  currentPage = pagination.INITIAL_PAGE,
  pageInterval = pagination.INITIAL_ROWS_PER_PAGE,
  resourceCount = 0
) => ({
  currentPage,
  totalPage: Math.ceil(resourceCount / pageInterval),
  totalItems: resourceCount,
  pageInterval
});

export const getSentenceCase = (string) => string.charAt(0).toUpperCase() +
  string.substr(1).toLowerCase();

export const objectToQueryParams = (query = {}) => {
  const queryKeys = Object.keys(query);

  if (!queryKeys.length) {
    return '';
  }

  return `?${queryKeys
    .map((key) => `${key}=${query[key]}`)
    .join('&')}`;
};

const isValidTimezone = (tz) => {
  try {
    // Test if the timezone is valid by trying to use it
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (error) {
    return false;
  }
};

// Get a safe timezone with fallbacks
const getSafeTimezone = () => {
  const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Check if detected timezone is valid
  if (detectedTimezone && isValidTimezone(detectedTimezone)) {
    return detectedTimezone;
  }

  // Fallback to common timezones that are likely to work
  const fallbackTimezones = [
    'America/New_York',
  ];

  for (const tz of fallbackTimezones) {
    if (isValidTimezone(tz)) {
      return tz;
    }
  }

  // Last resort - return UTC (should always work)
  return 'UTC';
};

// export const dateToDisplayFormat = (date) =>
//   dayjs(date)
//     .tz(
//       Intl.DateTimeFormat().resolvedOptions().timeZone
//         ? Intl.DateTimeFormat().resolvedOptions().timeZone
//         : 'America/New_York'
//     )
//     .format(config.DATE_FORMAT);

export const dateToDisplayFormat = (date) => {
  try {
    const safeTimezone = getSafeTimezone();

    return dayjs(date).tz(safeTimezone).format(config.DATE_FORMAT);
  } catch (error) {
    // Final fallback - use local time without timezone conversion
    console.warn('Timezone conversion failed, using local time:', error);
    return dayjs(date).format(config.DATE_FORMAT);
  }
};
